import { openModal } from '@core/components/ModalStack';
import { AddEditEventModalProps } from './AddEditEventModal';
import {CalendarEventObject, CalendarEventResponse} from "@business/entities/calendar_event";
import {SystemCalendarBloc} from "@modules/common/SystemCalendar/SystemCalendarBloc";
import {AddEditEventModalBloc} from "@modules/common/SystemCalendar/AddEditEventModal/AddEditEventModalBloc";

export async function openAddEditEventModal(props: AddEditEventModalProps) {
  const { AddEditEventModal } = await import('./AddEditEventModal');

  openModal(AddEditEventModal, props);
}

export async function viewEventModal(props: {
    bloc: SystemCalendarBloc;
    userEmails: { label: string; value: any; email: any }[];
    event: CalendarEventResponse;
    object: CalendarEventObject
    // Details only (user-wide calendar): hides Edit and Delete
    viewOnly?: boolean;
}) {
    const { ViewEventModal } = await import('./ViewEventModal');

    openModal(ViewEventModal, props);
}
